import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M13.925 7.292 16.84 10l-2.916 2.708M16.633 10H9.758m3.75-6.042H6.425c-.92 0-1.667.747-1.667 1.667v8.75c0 .92.746 1.667 1.667 1.667h7.083" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);